export const REGISTER = 'REGISTER';
export const REGISTER_SUCCESSFUL = 'REGISTER_SUCCESSFUL';
export const REGISTER_FAILED = 'REGISTER_FAILED';


export const SET_REGISTER_LOADING = 'SET_REGISTER_LOADING';



